import { WeightBracketPriceMapper } from "./weight-bracket-price.mapper";
import { WeightBracketPriceDict } from "./weight-bracket-price-dict.type";
import { WeightBracketPrice } from "./weight-bracket-price.model";

export class WeightBracketPriceDictMapper {
  public static toDict(data: any = []): WeightBracketPriceDict {
    const containers = <WeightBracketPriceDict>{};

    if (Array.isArray(data)) {
      data.forEach((containerObject) => {
        containers[containerObject.name] =
          WeightBracketPriceMapper.map(containerObject);
      });
    }

    return containers;
  }

  public static toArray(data: WeightBracketPriceDict): WeightBracketPrice[] {
    return Object.keys(data).map(
      (weightBracketName) =>
        new WeightBracketPrice(
          weightBracketName,
          data[weightBracketName].value,
        ),
    );
  }
}
